module.exports = __webpack_public_path__ + "epdf-app/dashboard/resumption/resumption-modal-choose-3SHKIVgq.html";